export default __webpack_public_path__ + "static/media/splashScreen.ebe46901.png";